import BaromoneyTransferSetting from '@/entity/BaromoneyTransferSetting';
import { i18n } from '@/locales';
import { autoLcBaromoneyTransferSetting } from '@/locales/ko/views/baromoney-transfer-setting';
const lc = autoLcBaromoneyTransferSetting();
export default class BaromoneyTransferSettingVM extends BaromoneyTransferSetting {
    // eslint-disable-next-line no-useless-constructor
    constructor(baromoneyTransfer) {
        super(baromoneyTransfer);
    }
    get isDeletedToString() {
        return this.isDeleted ? i18n.t('common.use') : i18n.t('common.delete');
    }
    get movePeriodDayToString() {
        if (this.movePeriodDay === 0) {
            return lc('detail.day.everyday');
        }
        if (this.movePeriodDay === 35) {
            return lc('detail.day.monthly_end');
        }
        return `${lc('detail.day.monthly')} ${this.movePeriodDay}${lc('detail.day.one')}`;
    }
}
